import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {black, marketingMobileCuttoff, white} from "@css/constants";

type InfoBlockCheckListIconColProps = {
  imageUrl: string;
}

type InfoBlockCheckListBottomSolidProps = {
  index: number;
  textColor?: string;
}

type InfoBlockCheckListTextProps = {
  textColor?: string;
}

export const InfoBlockCheckListContainer = styled('div')<{ isLast: boolean }>(props => css`
  display: flex;
  margin-bottom: ${props.isLast ? '0' : '20px'};
  flex-direction: column;
  padding-top: 10px;
`)

export const InfoBlockCheckListIconCol = styled.div<InfoBlockCheckListIconColProps>`
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto;
  background-image: url(${props => props.imageUrl});
  position: relative;
  height: 30px;
  min-width: 45px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    margin-left: 20px;
    min-width: 30px;
  }
`;

export const InfoBlockCheckListTextCol = styled('div')(css`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`)
export const InfoBlockCheckListTitle = styled.h3<InfoBlockCheckListTextProps>`
  ${fontSize(22)};
  ${FontNormal(600)};
  color: ${props => props.textColor ? props.textColor : black};
  margin-bottom: 5px;
`;

export const InfoBlockCheckListText = styled.h3<InfoBlockCheckListTextProps>`
  ${fontSize(16)};
  ${FontNormal(500)};
  color: ${props => props.textColor ? props.textColor : black};
  width: 74%;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    width: 80%;
  }
`

export const InfoBlockCheckListDiv = styled.div`
  display: flex;
  margin-bottom: 26px;
`;

export const InfoBlockCheckListBottomSolid = styled.div<InfoBlockCheckListBottomSolidProps>`
  border: 1px solid ${props => props.textColor ? white : '#B1B7BA'};
  display: ${props => props.index === 0 ? 'flex' : 'none'};
  opacity: 0.5;
  width: 70%;
  margin-left: 25px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    width: 70%;
    margin-left: 0;
    align-self: center;
  }
`;